// Copyright (c) 2025 by Audere

import { Avatar } from "@mui/material";

import { getInitials } from "../utils/stringUtils";
import { stringToColor } from "../utils/styles";
import { UserData } from "../features/api/labelApiSlice";

export const CustomAvatar: React.FC<{ user: UserData }> = ({ user }) => {
  return user.picture ? (
    <Avatar alt={user.name} src={user.picture}>
      {getInitials(user.name)}
    </Avatar>
  ) : (
    <Avatar sx={{ backgroundColor: stringToColor(user.name) }}>
      {getInitials(user.name)}
    </Avatar>
  );
};
